import React from "react";

// value: {id, route, routes, type, withContent, withContentKeyRoute,
//         goPageIndex, goPageBack, goPageShow, goPageCreate,
//         setTitle, breadcrumb, checkPermission}
export const ContextPage = React.createContext(null);
